/**************
 Product Swiper
 **************/

// setup product swiper
const productSwiper = new Swiper(document.querySelector(".productVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    zoom: {
        maxRatio: 3,
        minRation: 1
    }
});

// slide change
productSwiper.on('slideChange', function () {
    // update the thumbnail active class
    document.querySelectorAll(".productVisualThumbsSlide.active").forEach(el => el.classList.remove("active"));
    document.querySelectorAll(`.productVisualThumbsSlide[data-index="${productSwiper + 1}"]`).forEach(el => el.classList.add("active"));

    // pause all videos
    document.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
        element.pause();
    });
});

// auto zoom on enter
document.querySelector('.productVisualSwiper').addEventListener('mouseenter', () => {
    productSwiper.zoom.in();
})
// return to normal on leave
document.querySelector('.productVisualSwiper').addEventListener('mouseleave', () => {
    productSwiper.zoom.out();
})

// play video on slide play click
document.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productVisualSwiperSlide").querySelector("video");

        // remove play button if it hasn't already been removed
        this.querySelector(".productVisualSwiperSlidePlay")?.remove();

        if (video) {
            // show controls
            video.controls = true;

            // play video
            video.play();
        }
    });
});

// change slide on thumbnail click
document.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideTo(this.dataset.index - 1);
    });
});

// mobile thumbnail swiper
const thumbnailSwiper = new Swiper(document.querySelector(".productVisualThumbs .swiper"), {
    slidesPerView: 'auto',
    loop: true,
    navigation: {
        nextEl: '.productVisualThumbs .swiper-button-next',
        prevEl: '.productVisualThumbs .swiper-button-prev',
    },
});

// mobile active add
document.querySelectorAll(".productVisualThumbsSlide.swiper-slide").forEach(element => {
    element.addEventListener("click", function () {
        document.querySelector('.productVisualThumbsSlide.swiper-slide.active')?.classList.remove('active');
        this.classList.add('active');
    });
});

/**************
 Product Variants
 ***************/

const productFormATC = document.querySelector("#productFormATC");

// update active variant on input changes
document.querySelectorAll(".productOptionItemValuesLabel").forEach(function (element) {
    element.addEventListener("input", function () {
        // remove active class from all labels
        document.querySelectorAll(".productOptionItemValuesLabel").forEach(element => {
            element.classList.remove("active");
        });

        // update active class of label to show selected if there is a checked input
        document.querySelectorAll(`.productOptionItemValuesLabelInput:checked`).forEach(element => {
            element.closest(".productOptionItemValuesLabel").classList.add("active");
        });

        // update color names
        if (element.dataset.name) {
            // update color label if exists
            if (element.closest('.productOptionItem').querySelector(".productOptionItemLabel span")) {
                element.closest('.productOptionItem').querySelector(".productOptionItemLabel span").textContent = element.dataset.name;
            }

            // if color bubble beneath swiper, update active
            if (document.querySelector('.productVisualOptionsItem.active')) {
                document.querySelector('.productVisualOptionsItem.active').classList.remove('active');
                document.querySelector(`.productVisualOptionsItem[data-name="${element.dataset.name}"]`).classList.add('active');
            }
        }

        //update bottom ATC to match top
        const value = element.querySelector('input').value;
        const name = element.querySelector('input').name;
        document.querySelector(`#productBottomRight select[name="${name}"]`).value = value;

        updateBottomPrice();
        updateProduct();
    });
})

//update quantity on input change
document.querySelector("#productFormQuantityInput")?.addEventListener("input", function () {
    document.querySelector("#productBottomQuantityInput").value = this.value;
});
document.querySelector("#productBottomQuantityInput")?.addEventListener("input", function () {
    document.querySelector("#productFormQuantityInput").value = this.value;
});

// v3/4 compatibility - color options selection from below swiper
document.querySelectorAll(".productVisualOptionsItem")?.forEach(element => {
    element.addEventListener("click", function () {

        if (this.classList.contains('active')) return;
        this.parentElement.querySelector('.productVisualOptionsItem.active')?.classList.remove('active');
        this.classList.add('active');

        const colorName = this.dataset.name;
        const relatedInput = document.querySelector(`.productOptionItemValuesLabelInput[data-name="${colorName}"]`);
        if (relatedInput) {
            relatedInput.click();
        }
    });
})

// update active variant
function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productOptionItemValuesLabelInput:checked`).forEach(element => {
        options.push(element.value);
    });

    // in case there is only the default variant, default means no .productOptionItem
    if (options.length !== 0) {
        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });
    }

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        productFormATC.classList.add("disabled");
        productFormATC.textContent = "Not Available";
        return;
    }

    // update variant
    document.querySelector('#productFormVariant').value = activeVariant.id;

    // update price
    document.querySelector("#productPriceReal").textContent = price(activeVariant.price);
    if (activeVariant.compare_at_price > activeVariant.price) {
        document.querySelector("#productPriceReal").classList.add("sale");
        document.querySelector("#productPriceCompare").textContent = price(activeVariant.compare_at_price);
        document.querySelector("#productPriceSavings").textContent = `Save ${Math.round((activeVariant.compare_at_price - activeVariant.price) * 100 / activeVariant.compare_at_price)}%`;
    } else {
        document.querySelector("#productPriceReal").classList.remove("sale");
        document.querySelector("#productPriceCompare").textContent = "";
        document.querySelector("#productPriceSavings").textContent = "";
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        productFormATC.classList.remove("disabled")
        productFormATC.textContent = "Add To Cart";
    } else {
        productFormATC.classList.add("disabled");
        productFormATC.textContent = "Sold Out";
    }

    try {
        // update afterpay variant
        afterpay_current_variant = activeVariant;

        // update display price
        const afterpayElement = document.querySelector('[data-mpid="muscle-mat.myshopify.com"]');
        if (afterpayElement) afterpayElement.dataset.amount = activeVariant.price / 100;
    } catch (e) {
        console.error("Error updating afterpay pricing")
    }

    try {
        // if variant has featured_image, slide to image
        if (activeVariant.featured_image) {
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }
    } catch (e) {
        console.error("Variant has no featured image");
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

/**************
 Product ATC
 ***************/

document.querySelector("#productForm").addEventListener("submit", async function (e) {
    e.preventDefault();

    // add loading animation
    document.querySelector("#productFormATC").classList.add("loading");

    // add product
    const addedProduct = await addProduct(new FormData(this));

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    document.querySelector("#productFormATC").classList.remove("loading");

    // open cart
    await openCart(addedProduct);
});

/**************
 Product Bottom
 ***************/

// show on scroll
let isVisible = false;
const productBottom = document.querySelector('#productBottom');

// listen if the original ATC button is scrolled off screen
window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const buttonOffsetTop = productFormATC.offsetTop;

    if (scrollTop > buttonOffsetTop && !isVisible) {
        productBottom.classList.add('active');
        isVisible = true;
    } else if (scrollTop <= buttonOffsetTop && isVisible) {
        productBottom.classList.remove('active');
        isVisible = false;
    }
})

// update active variant on input changes
document.querySelectorAll(".productBottomOptionItem").forEach(function (el) {
    el.addEventListener("change", function () {
        // update top selection to match  bottom
        const value = el.value;
        document.querySelector(`.productOptionItemValuesLabel [data-name="${value}"]`).click();
        updateBottomPrice();
    });
})
// initial variant
let bottomVariant = activeVariant;

// currency
let bottomCurrency = document.querySelector('#productBottomPrice').textContent.split(" ")[1];

// update active variant
function updateBottomPrice() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productBottomOptionItem`).forEach(select => {
        options.push(select.value);
    });

    // find new variant based on the options
    bottomVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (bottomVariant === null || bottomVariant === undefined) {
        document.querySelector("#productBottomATC").classList.add("disabled");
        document.querySelector("#productBottomATC").textContent = "Not Available";
        return;
    }

    // update variant
    document.querySelector('#productBottomVariant').value = bottomVariant.id;

    // update price
    document.querySelector("#productBottomPrice").textContent = price(bottomVariant.price) + ` ${bottomCurrency}`;

    // check if the variant is in stock
    if (bottomVariant.available) {
        document.querySelector("#productBottomATC").classList.remove("disabled")
        document.querySelector("#productBottomATC").textContent = "Add To Cart";
    } else {
        document.querySelector("#productBottomATC").classList.add("disabled");
        document.querySelector("#productBottomATC").textContent = "Sold Out";
    }
}

/**************
 Product ATC
 ***************/

document.querySelector("#productBottomRight").addEventListener("submit", async function (e) {
    e.preventDefault();

    // add loading animation
    document.querySelector("#productBottomATC").classList.add("loading");

    // add product
    const addedProduct = await addProduct(new FormData(this));

    // remove loading animation
    document.querySelector("#productBottomATC").classList.remove("loading");

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // open cart
    await openCart(addedProduct);
});
